import { px2rem, SkeletonBox } from "@moim/common";

export const CoinItemSkeleton = () => (
  <SkeletonBox width="100%" height={px2rem(60)} />
);
